<template>
  <div>
    <mdb-date-picker-2
      inline
      v-model="localDate"
      :options="options"
      :title="title"
      :label="label"
      @getValue="handleChange"
    />
  </div>
</template>

<script>
import { mdbDatePicker2 } from "mdbvue";
export default {
  name: "DataPicker",
  components: {
    mdbDatePicker2
  },
  props: {
    date: String,
    title: String,
    label: String
  },
  methods: {
    handleChange(val) {
      this.$emit("date", val);
    }
  },
  data() {
    return {
      localDate: this.date,
      options: {
        buttons: { ok: "Ok", clear: "Pyyhi", cancel: "Poistu" },
        week: ["MA", "TI", "KE", "TO", "PE", "LA", "SU"],
        placeholder: "Valitse ajankohta tai syötä muodossa YYYY-MM-DD",
        month: [
          "Tammikuu",
          "Helmikuu",
          "Maaliskuu",
          "Huhtikuu",
          "Toukokuu",
          "Kesäkuu",
          "Heinäkuu",
          "Elokuu",
          "Syyskuu",
          "Lokakuu",
          "Marraskuu",
          "Joulukuu"
        ]
      }
    };
  }
};
</script>

<style></style>
